import { populateCareer, populateCareerResult, populateCareerByCodeAndSource, populateGeoIds, getRelatedCareers,
  getCareers, getCareerForProfile, getLearnerExploreCareers, getCareerByCode } from '../api'

export const loadCareer = ({ state, commit }, code) => {
  return populateCareer(code).then((response) => {
    commit('LOAD_CAREER', response)
    return response
  })
}

export const loadRelatedCareers = ({ state, commit }, code) => {
  return getRelatedCareers(code).then(res => {
    return res
  })
}

export const loadCareerResult = ({ state, commit }, {careerCode, locationParam}) => {
  return populateCareerResult(careerCode, locationParam).then((response) => {
    commit('LOAD_CAREER_RESULT', response)
    return response
  })
}

export const loadCareerOneStopInfo = ({ state, commit }, code) => {
  let careerOneStopCode = code.split('.')[0] + '.00' // Always ensure trailing zeros for COS api
  let source = 'COS'
  return populateCareerByCodeAndSource(careerOneStopCode, source).then((response) => {
    commit('LOAD_CAREER_ONE_STOP_INFO', response)
    return response
  })
}

export const resetCareerResult = ({ state, commit }) => {
  commit('LOAD_CAREER_RESULT', {})
}

export const loadGeoIds = ({ state, commit }) => {
  return populateGeoIds().then((response) => {
    commit('LOAD_GEO_IDS', response)
    return response
  })
}

export const loadCareers = ({ state, commit }, {page, count, name}) => {
  return getCareers(page, count, name).then(res => {
    return res
  })
}
export const loadCareerForProfile = ({ state, commit }, {page, count, name, type}) => {
  return getCareerForProfile(page, count, name, type).then(res => {
    return res
  })
}
export const loadCareerByCode = ({ state, commit }, code) => {
  return getCareerByCode(code)
}

export const loadLearnerExploreCareers = ({ state, commit }) => {
  return getLearnerExploreCareers()
}



// WEBPACK FOOTER //
// ./src/app/career/vuex/actions.js